var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BigNumber } from "bignumber.js";
import { getAbandonSeedAddress } from "@ledgerhq/cryptoassets";
import { calculateAmount } from "./logic";
import { buildTransaction } from "./js-buildTransaction";
import { fakeSignExtrinsic } from "./js-signOperation";
/**
 * Fetch the transaction fees for a transaction
 *
 * @param {Account} a
 * @param {Transaction} t
 */
const getEstimatedFees = (polkadotAPI) => ({ a, t }) => __awaiter(void 0, void 0, void 0, function* () {
    const transaction = Object.assign(Object.assign({}, t), { recipient: getAbandonSeedAddress(a.currency.id), 
        // Always use a fake recipient to estimate fees
        amount: calculateAmount({
            a,
            t: Object.assign(Object.assign({}, t), { fees: new BigNumber(0) }),
        }) });
    const { unsigned, registry } = yield buildTransaction(polkadotAPI)(a, transaction);
    const fakeSignedTx = yield fakeSignExtrinsic(unsigned, registry);
    const payment = yield polkadotAPI.getPaymentInfo({
        a,
        t: transaction,
        signedTx: fakeSignedTx,
    });
    return new BigNumber(payment.partialFee);
});
export default getEstimatedFees;
//# sourceMappingURL=js-getFeesForTransaction.js.map